export default [
  {
    path: '/vidcents/bands',
    name: 'Bands',
    component: () =>
        import(/* webpackChunkName: 'vidcents-bands' */ './views/Bands.vue')
  },
  {
    path: '/vidcents/manage',
    name: 'Manage VidCents',
    component: () =>
      import(/* webpackChunkName: 'vidcents-manage' */ './views/Manage.vue')
  },
  {
    path: '/vidcents/transaction-history',
    name: 'Transaction History',
    component: () =>
      import(
        /* webpackChunkName: 'vidcents-transaction-history' */ './views/TransactionHistory.vue'
      )
  },
  {
    path: '/vidcents/paypal',
    name: 'PayPal',
    component: () =>
      import(/* webpackChunkName: 'vidcents-paypal' */ './views/PayPal.vue')
  },
  {
    path: '/vidcents/video-tracks-scan',
    name: 'Video Tracks Scan',
    component: () =>
      import(
        /* webpackChunkName: 'vidcents-video-tracks-scan' */ './views/VideoTracksScan.vue'
      )
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: () =>
      import(
        /* webpackChunkName: 'invoices' */ './views/Invoices.vue'
        )
  }
]
